/**
 * EntityListItem
 *
 * @ngdoc    object
 * @module   books.data
 * @name     books.data.EntityListItem.type:EntityListItem
 * @description
 * Provides a function to generate an EntityListItem object. If a source object
 * has been provided, values will be copied over.
 **/

/* @ngInject */
export function entityListItem(SERVER) {
  function EntityListItem(src) {
    /***************************************************************************
     * Properties
     ***************************************************************************/
    /** Self Reference. */ var mThis = this;

    /** Entity ID */ mThis.id = 0;
    /** Active. */ mThis.active;
    /** Login ID (Staff ID) */ mThis.loginID;
    /** Full Name.(F MI L, if available) */ mThis.fullName;
    /** Entity Name (L F MI, if available */ mThis.name;
    /** List of associated entity types */ mThis.types = [];
    /** Entity Notes */ mThis.notes;
    /** Entity EMail Address */ mThis.email;
    /** Entity Phone Number */ mThis.phone;
    /** Entity Cell Number */ mThis.cell;
    /** Is Member flag. */ mThis.isMember;
    /** Has Store Login. */ mThis.hasStoreLogin;

    /*-------------------------------------*/
    /* Copy source properties if available */
    /*-------------------------------------*/
    if (src) angular.extend(mThis, src);
  }

  /*****************************************************************************
   * Client-side Properties
   *****************************************************************************/
  /*-------------------*/
  /* Display Accessors */
  /*-------------------*/
  /** Label function to display the Entity information, formatted string with name and student ID. */
  Object.defineProperty(EntityListItem.prototype, 'labelFunction', {
    get: function () {
      return (
        (this.name || '') + (this.studentID ? ' (' + this.studentID + ')' : '')
      );
    }
  });

  /*------------------------------*/
  /* Entity Type Flags - Based on */
  /* type present in Types array  */
  /*------------------------------*/
  /** Is Club Entity Type Flag. */
  Object.defineProperty(EntityListItem.prototype, 'isClub', {
    get: function () {
      return this.type == SERVER.BooksDBConstants.ET_CLUB;
    }
  });

  /** Is Group Entity Type Flag. */
  Object.defineProperty(EntityListItem.prototype, 'isGroup', {
    get: function () {
      return this.type == SERVER.BooksDBConstants.ET_GROUP;
    }
  });

  /** Is Other Entity Type Flag. */
  Object.defineProperty(EntityListItem.prototype, 'isOther', {
    get: function () {
      return this.type == SERVER.BooksDBConstants.ET_OTHER;
    }
  });

  /** Is Parent Entity Type Flag. */
  Object.defineProperty(EntityListItem.prototype, 'isParent', {
    get: function () {
      return this.type == SERVER.BooksDBConstants.ET_PARENT;
    }
  });

  /** Is Grandparent Entity Type Flag. */
  Object.defineProperty(EntityListItem.prototype, 'isGrandparent', {
    get: function () {
      return this.type == SERVER.BooksDBConstants.ET_GRANDPARENT;
    }
  });

  /** Is Community Partner Entity Type Flag. */
  Object.defineProperty(EntityListItem.prototype, 'isCommunityPartner', {
    get: function () {
      return this.type == SERVER.BooksDBConstants.ET_COMMUNITY_PARTNER;
    }
  });

  /** Is Student Entity Type Flag. */
  Object.defineProperty(EntityListItem.prototype, 'isStudent', {
    get: function () {
      return this.type == SERVER.BooksDBConstants.ET_STUDENT;
    }
  });

  /** Is Teacher Entity Type Flag. */
  Object.defineProperty(EntityListItem.prototype, 'isTeacher', {
    get: function () {
      return this.type == SERVER.BooksDBConstants.ET_TEACHER;
    }
  });

  /** Is Vendor Entity Type Flag. */
  Object.defineProperty(EntityListItem.prototype, 'isVendor', {
    get: function () {
      return this.type == SERVER.BooksDBConstants.ET_VENDOR;
    }
  });

  return EntityListItem;
}
